import { Component } from '@angular/core';

@Component({
  selector: 'app-number-card-widget-skeleton',
  templateUrl: './number-card-widget-skeleton.component.html',
  styleUrls: ['./number-card-widget-skeleton.component.scss'],
  standalone: false,
})
export class NumberCardWidgetSkeletonComponent {}
